<template>
  <div class="about">
    <div class="about_tab">
      <div
        :class="['about_tab_item', tabIndex == item.id ? 'line' : '']"
        :data-tab="item.id"
        v-for="item in tabList"
        :key="item.id"
        @click="chooseTab($event)"
      >
        {{ item.tab }}
      </div>
    </div>
    <div class="about_company" v-show="tabIndex == 1">
      <div class="about_company_title wow animate__animated animate__zoomIn">
        公司介绍
      </div>
      <div class="about_company_1 wow animate__animated animate__fadeInUpBig">
        <div class="about_company_text">
          鼎函科技有限公司始创于2019年。公司创立以来，响应国家"放管服"号
          召，落实优化营商环境举措，促进银行、保险、担保金融产品的全线上
          化应用，提高效率降低企业成本，有效助力企业减负。根据客户需求提
          供专业定制软件产品、大数据服务运维、系统软件开发等业务。
          鼎函科技始终秉持"鼎力诚信、邀函即达"的理念，让数据多跑腿，让客
          户少走路的服务宗旨。以"诚信、专业、有社会责任感的科技公司"为发
          展目标，始终贯彻"诚信、合作、创新、卓越"的企业精神。
        </div>
        <!-- <img src="../../static/other/company_map_1.png" alt="" /> -->
        <VideoMedia ></VideoMedia>

      </div>
      <div class="about_company_title wow animate__animated animate__zoomIn">
        平台优势
      </div>
      <div class="about_company_1 wow animate__animated animate__fadeInUpBig">
        <div class="about_company_text">
          “鼎函电子保函服务平台”以国家信用大数据创新中心的公开数据为基础，运用独有保函科技技术满足不同客户的差
          异化需求，具有“快速、精准、灵活”的优势。打破线下保函出函流程长、小金额保函业务难受理的服务瓶颈，通过
          模块组合式平台架构，以完善的体系和标准化的服务连接招投标平台、
          保险、银行、担保等机构，结合区块链、大数
          据等数字技术保证电子保函的真实性，为客户节约大量时间成本、运营成本，切实减轻企业负担。
        </div>
        <img src="../../static/other/platform-advantages.jpg" alt="" />
      </div>

      <div class="about_company_title wow animate__animated animate__zoomIn">
        服务团队
      </div>
      <div class="about_company_1 wow animate__animated animate__fadeInUpBig">
        <img
          style="width: 100%"
          src="../../static/other/service-team.jpg"
          alt=""
        />
      </div>

      <div class="about_company_title wow animate__animated animate__zoomIn">
        公司资质
      </div>
      <div class="about_company_1 wow animate__animated animate__fadeInUpBig">
        <vueSeamless
          v-if="honorPic && honorPic.length != 0"
          :data="honorPic"
          :class-option="optionLeft"
          class="honor-box"
        >
          <ul class="content">
            <li
              class="row"
              v-for="(item, index) in honorPic"
              :key="index"
              :data-obj="JSON.stringify(item)"
              :data-id="index + 1"
            >
              <img
                :src="item.img"
                :style="{ width: item.width > item.height ? '200px' : '150px' }"
              />
              <div
                class="text"
                :style="{ width: item.width > item.height ? '200px' : '150px' }"
              >
                {{ item.title }}
              </div>
            </li>
          </ul>
        </vueSeamless>
      </div>
    </div>
    <div class="service_con" v-show="tabIndex == 2">
      <img src="../../static/other/feedback_2.png" alt="" />
      <div class="service_con_form">
        <el-form
          label-position="right"
          label-width="100px"
          :model="collaborateBox"
        >
          <el-form-item label="所在地：">
            <el-input
              v-model="cooperationArea"
              placeholder="请输入所在区域或城市"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input
              v-model="phoneNumber"
              placeholder="请输入手机号码"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input v-model="code" placeholder="请输入验证码">
              <template slot="append">
                <span v-show="show" @click="getCode" style="cursor: pointer"
                  >获取验证码</span
                >
                <span v-show="!show">{{ count }}秒重发</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="about_company about_adress" v-show="tabIndex == 3">
      <div class="about_company_1" style="margin-bottom: 100px">
        <div class="main-wrapper-pane" id="mapContainer"></div>
        <div class="adress_con">
          <p>全国统一客服电话</p>
          <p>400-6399580</p>
          <p>商务合作：19943433777</p>
          <p>电子邮箱：liuyang@dinghanwang.com</p>
          <p>公司地址：北京市朝阳区双井街道西大望路22号合生汇写字楼702室</p>
          <div style="display: flex">
            <div class="adress_img_con">
              <img src="../../static/other/footer-img1.jpg" alt="" />
              <span>微信公众号</span>
            </div>
            <div class="adress_img_con">
              <img src="../../static/other/footer-img3.jpg" alt="" />
              <span>微信客服</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zhaopin_con" v-show="tabIndex == 4">
      <!-- <img src="../../static/other/feedback_1.png" alt="" />
      <div class="service_con_form">
        <el-form label-position="right" label-width="100px" :model="opinionBox">
          <el-form-item label="联系方式：" >
            <el-input v-model="opinionBox.contact"  placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="意见反馈">
            <el-input  :rows="4" type="textarea" v-model="opinionBox.opinion"  placeholder="请输入意见反馈"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div> -->
      <div class="service_con_zhaopin">
        <img
        style="width: 100%; height: 100%"
        src="../../static/other/zhaopin.png"
        alt=""
      />
        <div class="service_con_zhaopin_con">
          <div class="zhaopin_con_item" style="left: 407px; top: 128px">
            <p @click="getInfo('省市区市场负责人')">省市区市场负责人</p>
          </div>
          <div class="zhaopin_con_item" style="left: 618px; top: 128px">
            <p @click="getInfo('非车险产品管理岗位')">非车险产品管理岗位</p>
          </div>
          <div class="zhaopin_con_item" style="left: 303px; top: 345px">
            <p @click="getInfo('JAVA高级开发工程师')">JAVA高级开发工程师</p>
            <p @click="getInfo('JAVA中级开发工程师')">JAVA中级开发工程师</p>
            <p @click="getInfo('前端开发工程师')">前端开发工程师</p>
          </div>
          <div class="zhaopin_con_item" style="left: 838px; top: 128px">
            <p @click="getInfo('新媒体运营专员')">新媒体运营专员</p>
          </div>
          <div class="zhaopin_con_item" style="left: 561px; top: 362px">
            <p @click="getInfo('财务人员')">财务人员</p>
            <p @click="getInfo('法务专员')">法务专员</p>
          </div>
          <div class="zhaopin_con_item" style="left: 772px; top: 381px">
            <p @click="getInfo('客服人员')">客服人员</p>
          </div>
        </div>
      </div>


      <div>
        <div style="font-weight: 700;">联系我们：</div>

        <div style="margin-top: 30px;">请将个人简历发送至邮箱：hr@dinghanwang.com （邮件标题请标注“应聘职位”+“地区”+“姓名”+“联系电话”）</div>
        <div ></div>
      </div>
    </div>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '354px', height: '216px' }"
    />
    <el-dialog
      :title="title + '职位招聘详情'"
      :visible.sync="dialogVisible"
      width="30%"
      @close="dialogVisible == false"
    >
      <div class="content">
        <div v-show="content == '省市区市场负责人'">
          地点：全国<br />
          <br />
          工作职责：<br />
          1、拓展、建立、维护与加强同行政管理平台、大型企业招采平台等相关单位的良好关系，为公司营造有利的商业运营环境；<br />
          2、积极关注国家政策与行业趋势等方面的最新情况，商业市场等方面的高效策略与整体实施计划；<br />
          3、根据公司规划与不同区域的具体情况，提升公司的认知度与品牌形象，建立深入的市场关系网络与工作机制，制定详细的工作规划与流程，务实把控进度与效果；<br />
          4、负责管理项目运维工作进度及质量，定期对项目与团队成员开展评估、总结与培训等工作，对具体业绩进行考评与激励；<br />
          5、做好各项工作应急预案，领导交办的其他工作；<br />
          任职要求： <br />
          1、全日制本科及以上学历，市场营销、保险相关专业，985、211院校毕业优先；
          工作经验8年以上 ，具有保险、IT项目销售经验者优先；
          性格开朗，具有良好的团队合作精神及较强的公关协调能力；<br />
        </div>
        <div v-show="content == '非车险产品管理岗位'">
          地点：北京<br />
          <br />
          工作职责：<br />
          1、 参与非车险产品设计、分析、管理，整理并分析产品特性；<br />
          2、 指导各省分公司非车险业务设计、销售，以及业务推动、培训工作；<br />
          任职要求：<br />
          1、
          全日制本科以上需要有大型保险公司或保险经纪公司工作两年以上相关岗位经验，可以适应出差工作；<br />
          2、年龄：35以下，男女不限；<br />
        </div>
        <div v-show="content == 'JAVA高级开发工程师'">
          地点：北京/成都<br />
          <br />
          3年以上Java开发工作经验，1年以上带领3人（含）以上团队经验。有保险行业业务软件开发经验优先。<br />
          任职要求：<br />
          1、全日制本科学历；<br />
          2、有保险行业业务软件开发经验优先；<br />
          3、有基本沟通和交流业务需求并做相应功能设计能力；<br />
          4、熟练使用SpringCloud、Springboot、VUE等常用框架；<br />
          5、熟悉Mysql、Oracle等数据库，对数据库优化有一定的了解；<br />
          6、熟悉redis和mongodb等NoSql数据库；<br />
          7、熟悉ActiveMQ、RabbitMQ等MQ中间件；<br />
          8、具有良好的逻辑思维能力 、良好的表达和沟通能力
          ，具备良好的团队合作精神 、有责任心、较强的承受压力能力；<br />
        </div>
        <div v-show="content == 'JAVA中级开发工程师'">
          地点：北京/成都<br />
          <br />

          2年以上Java开发工作经验，有保险行业业务软件开发经验优先。<br />
          任职要求：<br />
          1. 全日制本科及以上学历；<br />
          2. 熟练使用SpringCloud、Springboot、VUE等常用框架；<br />
          3. 熟悉Mysql、Oracle等数据库，对数据库优化有一定的了解；<br />
          4. 熟悉redis和mongodb等NoSql数据库；<br />
          5. 熟悉ActiveMQ、RabbitMQ等MQ中间件；<br />
          6. 具有良好的逻辑思维能力 、良好的表达和沟通能力
          ，具备良好的团队合作精神 、有责任心、较强的承受压力能力；<br />
        </div>
        <div v-show="content == '前端开发工程师'">
          地点：北京<br />
          <br />

          1.精通 JavaScript 、HTML5 、CSS 等web前端技术，<br />
          2.精通Vue ，Element UI NodeJs前端框架及类库。<br />
          3.熟悉 Web 前端组件化、模块化开发模式和前端构建工程。<br />
          4.有移动端H5研发基础，掌握 PC端系统与移动端系统的页面适配。<br />
          4.熟悉HTTP、TCP协议、浏览器各类缓存方式用法。<br />
          5.熟练使用npm/webpack/gulp等工具链；<br />
          6.负责公司网站（PC端与移动端）、业务系统的前端设计与开发。<br />
          7.深入理解用户体验，思路清晰、善于沟通与团队配合。<br />

          任职要求：<br />
          统招本科及以上学历，3年及以上开发经验。<br />
        </div>
        <div v-show="content == '新媒体运营专员'">
          地点：北京<br />
          <br />

          工作职责：<br />
          1、负责品牌社会化媒体日常运营以及推广，协助完成新媒体平台管理与发展规划，促进各新媒体账号知名度的提高；<br />
          2、根据品牌阶段性的传播目标，输出新媒体资源的策划方案，并准确把握新媒体内容营销的定位和方向，完成内容的选题、策划、组织工作；<br />
          岗位要求：<br />
          1、本科或以上的学历，中文专业优先，有一年以上新媒体运营经验，对新媒体运营有高度的热情；<br />
          2、富有创意、思维活跃，文笔好，书面和口头沟通能力强，熟悉网络语言写作特点，能独立撰写文案、脚本，短视频的拍摄剪辑；<br />
          3、有高度的责任心，高效的执行力，乐于接受新事物，学习能力强，能协助公司新媒体项目的策划与执行，有ps、pr视频剪辑基础优先；<br />
        </div>
        <div v-show="content == '财务人员'">
          地点：北京<br />
          <br />

          工作职责：<br />
          1、 独立处理账务，汇算清缴，申报纳税等；<br />
          2、 对已审核的原始凭证及时填制记帐；<br />
          3、 负责员工报销费用的审核、凭证的编制和登帐；<br />
          4、 财务报表分析工作，利用财务分析数据帮助公司进行经营数据分析；<br />
          任职要求：<br />
          1. 能独立完成企业全套账务处理工作；<br />
          2. 财务相关专业，有会计从业资格证；<br />
          3. 工作认证仔细，有责任心，有良好的职业操守和职业道德；<br />
          4.
          财务、会计专业统招本科以上学历，3年以上相关工作经验，熟悉国家财务、税务相关法规政策；<br />
          5. 熟悉会计报表的处理，会计法规和税法，熟练使用U8用友财务软件。<br />
        </div>
        <div v-show="content == '法务专员'">
          地点：北京<br />
          <br />
          工作职责：<br />
          1.建立公司合同管理制度，负责起草、审核、修订公司各类合同文本、规章制度等法律文件，制定公司各类的标准合同文本；<br />
          2.参与公司有关重大决议、经营行为、规章制度制定及其他重要法律文件的合法性审查，进行法律风险分析并提供防范措施和意见。<br />
          3.代表公司处理诉讼、非诉纠纷、仲裁等事务，维护公司合法权益。
          协助公司对项目投资、及其他重大经营行为提供法务支持。<br />
          5.协助人事行政部对员工违反公司制度、损害公司利益的案件调查、处理，对存在的风险及隐患进行发现并及时汇报。<br />
          6. 负责公司知识产权、法律维权等事务；<br />
          任职要求：<br />
          1. 统招法律本科及以上学历，熟悉保险行业优先，党员优先；<br />
          2. 熟悉合同法、著作权法等法律法规及政策；
          具有较强的文字功底和语言表达能力。 <br />
          3.工作认真细致，有原则性，有很好的执行能力，能够保质保量完成工作任务。<br />
        </div>
        <div v-show="content == '客服人员'">
          地点：北京<br />
          <br />
          工作职责：<br />
          1、负责应对客户咨询、受理投诉，对客户投诉、诉求进行解决和统计，并按公司要求分别归类，存档，并对相应条线和总裁室提出建议，对无法自行解决的问题及时转交；<br />
          2、按公司要求及时联系客户个案处理情况；<br />
          3、及时有效地将各类客户投诉以公司要求形式报告给相关部门；<br />
          4、及时跟进和通报个案处理状态，对数据库加以更新，处理后要及时进行客户回访，并建立投诉归档资料;<br />
          5、进行客户满意度调查和售后满意度调查;<br />
          6、客户管理和客户活动的管理;<br />
          7、协调与商务、销售等其他部门的工作，提供客服工作的支持。<br />
          任职要求：<br />
          1、22-28岁，熟悉保险行业优先；<br />
          2、工作认真细致，有原则性，有很好的执行能力，能够保质保量完成工作任务；<br />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">关 闭</el-button> -->
        <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueSeamless from "vue-seamless-scroll";
import Verify from "@/components/verifition/Verify.vue";
import VideoMedia from './VideoMedia.vue';
/* global AMap */
import {
  saveBusCooperatio,
  sendCheckCode,
  useCheckCode,
} from "../api/basic/index.js";
import { validatePhone, validateTelephone } from "@/utils/validate";
let imgBaseUrl =
  "https://dh-policy-bucket.obs.cn-east-3.myhuaweicloud.com/www/";
export default {
  name: "",
  mixins: [],
  components: {
    vueSeamless,
    Verify,
    VideoMedia
  },
  provide() {
    return {
      sendCheckCodeWithSlider: this.sendCheckCodeWithSlider
    };
  },
  data() {
    return {
      dialogVisible: false,
      content: "",
      title: "",
      cooperationArea: "",
      phoneNumber: "",
      dataForm: {
        cooperationArea: "",
        phoneNumber: "",
        policyNo: "",
        businessType: 1,
      },
      code: "",
      show: true,
      timer: null,
      count: "获取验证码",
      tabIndex: 1,
      tabList: [
        {
          tab: "公司简介",
          id: "1",
        },
        {
          tab: "商务合作",
          id: "2",
        },
        {
          tab: "联系我们",
          id: "3",
        },
        {
          tab: "诚聘英才",
          id: "4",
        },
      ],
      zhaopin: {},
      honorPic: [
        {
          title: "3A诚信经营",
          describe: "3A诚信经营示范单位证书",
          img: imgBaseUrl + "honor1.jpg",
          width: "4252",
          height: "3071",
        },
        {
          title: "高新技术企业",
          describe: "高新技术企业证书",
          img: require("../assets/honor/honor_gaoxin.png"),
          width: "4252",
          height: "3071",
        },
        {
          title: "电信运营资格许可证",
          describe: "中华人民共和国增值电信业务经营许可证",
          img: require("../assets/honor/honor_dxyy.png"),
          width: "531",
          height: "720",
        },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor2.jpg",
          width: "509",
          height: "720",
        },
        {
          title: "信息系统安全等级",
          describe: "信息系统安全等级保护备案",
          img: imgBaseUrl + "honor3.jpg",
          width: "1123",
          height: "793",
        },
        {
          title: "高新技术企业",
          describe: "高新技术企业",
          img: imgBaseUrl + "honor4.jpg",
          width: "720",
          height: "508",
        },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor5.jpg",
          width: "531",
          height: "720",
        },

        {
          title: "3A质量服务",
          describe: "3A质量服务诚信单位",
          img: imgBaseUrl + "honor6.jpg",
          width: "1799",
          height: "2542",
        },
        // {
        //   title: "3A诚信供应商",
        //   describe: "3A诚信供应商",
        //   img: require("../assets/honor/honor7.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        {
          title: "3A诚信经营",
          describe: "高新企业",
          img: imgBaseUrl + "honor8.jpg",
          width: "1799",
          height: "2542",
        },
        // {
        //   title: "3A诚信行业",
        //   describe: "3A诚信行业",
        //   img: require("../assets/honor/honor9.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        // {
        //   title: "3A诚信企业家",
        //   describe: "3A诚信企业家",
        //   img: require("../assets/honor/honor10.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        // {
        //   title: "守信用企业",
        //   describe: "守信用企业",
        //   img: require("../assets/honor/honor11.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        // {
        //   title: "3A资信等级",
        //   describe: "3A资信等级证书",
        //   img: require("../assets/honor/honor12.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        // {
        //   title: "诚信职业经理人",
        //   describe: "诚信职业经理人",
        //   img: require("../assets/honor/honor13.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        // {
        //   title: "立信单位",
        //   describe: "立信单位",
        //   img: require("../assets/honor/honor14.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        // {
        //   title: "3A企业信用等级",
        //   describe: "3A企业信用等级",
        //   img: require("../assets/honor/honor15.jpg"),
        //   width: "1799",
        //   height: "2542",
        // },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor16.png",
          width: "547",
          height: "752",
        },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor17.jpg",
          width: "2480",
          height: "3360",
        },

        {
          title: "信息安全管理体系",
          describe: "信息安全管理体系",
          img: imgBaseUrl + "honor18.jpg",
          width: "596",
          height: "841",
        },
        {
          title: "信息技术服务体系",
          describe: "信息技术服务体系",
          img: imgBaseUrl + "honor19.jpg",
          width: "596",
          height: "841",
        },
      ],
      collaborateBox: {
        number: "",
        name: "",
        phone: "",
        code: "",
      },
      opinionBox: {
        contact: "",
        opinion: "",
      },
    };
  },
  async created() {
    let tabIndex = this.$route.query.tabIndex;
    if (tabIndex) {
      this.tabIndex = tabIndex;
      document.documentElement.scrollTop = 0;
    }
    if(this.tabIndex ==3){
      this.loadMap();
    }
  },
  computed: {
    optionLeft() {
      return {
        step: 0.3,
        direction: 2,
      };
    },
  },
  watch: {
    $route: {
      handler: function (val) {
        this.tabIndex = val.query.tabIndex;
        if(this.tabIndex ==3){
          this.loadMap();
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    getInfo(art) {
      this.dialogVisible = true;
      this.title = art;
      this.content = art;
    },
    chooseTab(e) {
      let tabIndex = e.target.dataset.tab;
      this.tabIndex = tabIndex;
      console.log('sss',tabIndex)
      this.phoneNumber=''
      this.cooperationArea=''
      this.code = ''
      this.show = true
      this.timer=null
      this.count="获取验证码"
      if(this.tabIndex ==3){
        this.loadMap();
      }
    },
    getCode() {
      if (!this.phoneNumber) {
        this.$message.error("请先输入手机号");
        return;
      }
      if (
        (!validatePhone(this.phoneNumber) &&
          !validateTelephone(this.phoneNumber)) ||
        this.phoneNumber.length != 11
      ) {
        this.$message({
          title: "提示",
          message: "请输入正确的联系电话",
          type: "warning",
        });
      } else {
        //查询是否进行行为认证
        this.$refs.verify.show();
      }
    },
    // 发送验证码带滑块
    async sendCheckCodeWithSlider(sliderParams) {
      this.getVerifyCode();
      const params = {
        phone: this.phoneNumber,
        businessCode: "globalTemplate",
        graphicData:sliderParams,
      }
      try{
        await sendCheckCode(params)
        this.$message.success({
          title: '提示',
          message: '短信发送成功，请注意查收',
          type: 'success',
        });
        return true
      }catch (e){
        return false
      }
    },
    getVerifyCode() {
      this.show = false;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    submit() {
      if (this.phoneNumber && this.cooperationArea && this.code) {
        const phoneParams = {
          phone: this.phoneNumber,
          businessCode: "globalTemplate",
          checkCode: this.code,
        };
        useCheckCode(phoneParams).then((phoneRes) => {
          if (phoneRes.data.resultCode == "200") {
            this.saveBusCooperatio();
          }
        });
      } else {
        this.$message.error("请按照页面信息填写完整");
      }
    },
    saveBusCooperatio() {
      let dataForm= {
        cooperationArea: this.cooperationArea,
        phoneNumber:  this.phoneNumber,
        policyNo: "",
        businessType: 1,
      }
      saveBusCooperatio(dataForm).then((res) => {
        if (res.data.resultCode == "200") {
          this.clear()
          this.$message({
            message: "提交成功！稍后会有客服人员联系您。",
            type: "success",
          });
        }
      });
    },
    clear(){
      this.cooperationArea=''
      this.phoneNumber = "";
      this.code = "";
      this.show= true;
      this.timer=null;
      this.count="获取验证码";
    },
    loadMap() {
      try {
        this.initMap();
      } catch (error) {
        console.error('高德地图API加载失败:', error);
      }
    },
    initMap(){
      const loc = [116.48152, 39.893731]// 公司的经纬度
      const map = new AMap.Map('mapContainer', {
        center: loc,
        zoom: 15
      });
      const marker = new AMap.Marker({
        position: new AMap.LngLat(loc[0], loc[1])
      });
      map.add(marker);
      const infoWindow = new AMap.InfoWindow({
        content: '<b>公司地址：</b><br>北京市朝阳区双井街道西大望路22号合生汇写字楼702室'
      });
      marker.on('click', function () {
        infoWindow.open(map, marker.getPosition());
      });
      map.plugin(["AMap.ToolBar"], function() {
        map.addControl(new AMap.ToolBar());
      });
    }
  }
};
</script>

<style scoped >
.about {
  width: 1200px;
  margin: auto;
}
.about_tab {
  display: flex;
  justify-content: center;
  align-items: center;
}
.about_tab_item {
  flex-grow: 1;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
}
.line {
  border-bottom: 3px solid rgb(26, 127, 221);
  color: rgb(26, 127, 221);
}
.about_company {
  width: 100%;
  margin-top: 100px;
}
.about_company_title {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  margin: 50px 0;
}
.about_company_1 {
  width: 100%;
  display: flex;
  align-items: center;
}
.about_company_1 > img {
  width: 50%;
}
.about_company_text {
  /* width: 50%; */
  padding: 20px;
  text-indent: 30px;
  line-height: 36px;
}

.content {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: nowrap;
}
.content li {
  margin-right: 20px;
  list-style: none;
}
.honor-box {
  width: 100%;
  height: 400px;
  overflow: hidden;
  padding: 100px 0;
  box-sizing: border-box;
}
.about_cooperation {
  display: flex;
  align-items: center;
  justify-content: center;
}
.service_con {
  width: 1040px;
  height: 460px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 100px 0;
  padding: 50px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.service_con img {
  width: 350px;
  height: 350px;
  background: #e9e9e9;
}
.service_con_form {
  width: 560px;
  /* height: 350px; */
  margin-left: 20px;
}
.adress_img_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 50px;
}
.adress_con {
  padding-left: 30px;
  box-sizing: border-box;
}
.adress_con p {
  margin-bottom: 20px;
}
.adress_con p:nth-child(1) {
  font-size: 18px;
}
.adress_con p:nth-child(2) {
  font-size: 24px;
  color: rgb(26, 127, 221);
  font-weight: 600;
}
.adress_con img {
  width: 100px;
}
.text {
  text-align: center;
}
input,
button,
textarea,
select,
optgroup,
option,
ul,
li {
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
}
.zhaopin_con{
  width:1000px;
  margin: 100px 100px;


}
.service_con_zhaopin {
  width: 1000px;
  height: 529px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 100px 0;
  padding: 50px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
}
.service_con_zhaopin img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.service_con_zhaopin_con {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
}
.service_con_zhaopin_con p {
  margin-bottom: 15px;
  cursor: pointer;
}
.service_con_zhaopin_con p:hover {
  color: rgb(26, 127, 221);
}
.zhaopin_con_item {
  position: absolute;
}
.main-wrapper-pane{
  width: 600px;
  height: 450px;
  border:1px solid #ccc;
}
</style>
